import React, { useState, useEffect, useRef } from "react";
import { searchClient, DOCTORS, localAttributes, algoliaAttributes } from "assets/constants";
import { KeyValuePair, objectTypeProps } from "types";
import "instantsearch.css/themes/satellite.css";
import { InstantSearch } from "react-instantsearch";
import styles from "./SearchDoctors.module.scss";
import Text from "components/text/Text";
import { getAllClassNames, isDev, setParams } from "helpers";
import strings from "assets/strings";
import { doctorGenderOptions, visitDaysOptions, visitHoursOptions, languagesOptions } from "assets/constants";
//import { ArrowLeft, ArrowUp } from "assets/icons";
import SvgGenerator from "components/svgGenerator/SvgGenerator";
import Button from "components/buttons/button/Button";
import Popup from "components/popup/Popup";
import { CustomLocalSearchInput } from "components/inputs/customLocalSearchInput/CustomLocalSearchInput";
import { CustomCheckboxesLocal } from "components/buttons/customCheckboxesLocal/CustomCheckboxesLocal";
import settings from "assets/mergeSettings";
import { AlertPopup } from "components/popup/alertPopup/AlertPopup";
import { CustomDropdownCheckboxes, ItemProps } from "components/customDropdownCheckboxes/CustomDropdownCheckboxes";


export function SearchDoctors(props: objectTypeProps) {
  const { objectType } = props;
  const [expanded, setExpanded] = useState(false);
  const [medicalField, setMedicalField] = useState("");
  const [subField, setSubField] = useState<string[]>([]);
  const [subMedicalFields, setSubMedicalFields] = useState<ItemProps[]>([])
  const [subBubbles, setSubBubbles] = useState<ItemProps[]>([])
  const [selectedSubBubbles, setSelectedSubBubbles] = useState<string[]>([])
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [gender, setGender] = useState<string[]>([])
  const [daysOfWeek, setDaysOfWeek] = useState<string[]>([])
  const [workHours, setWorkHours] = useState<string[]>([])
  const [languages, setLanguages] = useState<string[]>([])
  //const [showPopup, setShowPopup] = useState(false)
  const [isMedicalFieldWithSubField, setIsMedicalFieldWithSubField] = useState(false)
  const divExpandRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<{ focusArrow: () => void }>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  let searchResultsPage: string = '';
  switch (objectType) {
    case 1:
      searchResultsPage = settings.doctorSearchResults;
      break;
    case 2:
      searchResultsPage = settings.dietSearchResults;
      break;
    case 3:
      searchResultsPage = settings.socialWorkerSearchResults;
      break;
    case 4:
      searchResultsPage = settings.medicalCenterSearchResults;
      break;
    case 5:
      searchResultsPage = settings.emergencySearchResults;
      break;
    case 6:
      searchResultsPage = settings.womenEmergencySearchResults;
      break;
    case 7:
      searchResultsPage = settings.pharmacySearchResults;
      break;
    case 8:
      searchResultsPage = settings.opticaSearchResults;
      break;
    case 9:
      searchResultsPage = settings.dentalSearchResults;
      break;
    default:
      searchResultsPage = settings.doctorSearchResults;
  }


  useEffect(() => {
    if (divExpandRef.current && expanded) {
      const firstInput = divExpandRef.current.querySelector('input');
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [expanded]);

  useEffect(() => {
    if (isMedicalFieldWithSubField && dropdownRef.current) {     
      dropdownRef.current.focusArrow(); // Call focusArrow
    }
  }, [isMedicalFieldWithSubField]);


  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle('show');
    }
  };


  const onSubmit = (event: any) => {
    event.preventDefault();    
    if (objectType == 1 && !medicalField && !name) {
      //setShowPopup(true)
      handleToggleVisibility();
    } else if (objectType != 1 && !city && !name) {
      handleToggleVisibility();
    }
    else {
      const formData: KeyValuePair[] = [
        { key: `${[localAttributes.localMedicalFieldName]}`, value: medicalField },
        { key: `${[localAttributes.localSubMedicalFieldNames]}`, value: subField.includes(strings.searchDoctors.allSubMedicalFields) ? '' : subField},
        { key: `${[localAttributes.localDoctorFieldName]}`, value: name },
        { key: `${[algoliaAttributes.Gender]}`, value: gender.join(',') },
        { key: `${[localAttributes.localCityCodeFieldName]}`, value: city },
        { key: `${[localAttributes.localdaysOfWeekFieldName]}`, value: daysOfWeek.join(',') },
        { key: `${[localAttributes.localWorkHoursFieldName]}`, value: workHours.join(',') },
        { key: `${[localAttributes.localLanguagesFieldName]}`, value: languages.join(',') },
      ];

      if (city && city.split(',').length == 1) {
        const cities = localStorage.getItem("cities");
        const citiesArr = cities && JSON.parse(cities);
        const locLat = citiesArr.find((c: any) => c.cityCode === city)?.latitude;
        const locLLong = citiesArr.find((c: any) => c.cityCode === city)?.longitude;
        if (locLat && locLLong) {
          formData.push({ key: `${[localAttributes.localLocFieldName]}`, value: `${locLat},${locLLong}` }, { key: `${[localAttributes.localRadiusFieldName]}`, value: "10000" });
        }
      }
      window.location.href = `${searchResultsPage}?${setParams(formData)}`;
    }
  };

  const updateSubBubbles = (bubbles: ItemProps[]) => {
    setSubBubbles(bubbles);
  }

  const handleSetSelectedCheckboxes = (subBubbles: string[]) => {
    setSelectedSubBubbles(subBubbles);
    setSubBubbles(subBubbles.map((item) => ({ value: item, label: item, isSelected: true })));
    setSubField(subBubbles);
  }

  const handleResetField = () => {
    setMedicalField('');
    setSubMedicalFields([]);
    setSubField([]);
    setSubBubbles([])
  }




  const handleSelectedMedicalField = (value: string, hasSubField: boolean = false) => {
    if (value == undefined && !hasSubField) return;
    setMedicalField(value);
    if (value && hasSubField) {
      setIsMedicalFieldWithSubField(true);
      //setSelectedSubBubbles([strings.searchDoctors.allSubMedicalFields]);
      const medicalFields = localStorage.getItem("medicalfields");
      const medicalFieldsArr = medicalFields && JSON.parse(medicalFields);
      const subFieldsVal = medicalFieldsArr.find((m: any) => m.medicalFieldName === value);
      const subFieldsObjects: ItemProps[] = subFieldsVal?.subMedicalFieldName.map((subfield: any) => {
        return { value: subfield, label: subfield, isSelected: false };
      });
      //setSubBubbles([{ value: strings.searchDoctors.allSubMedicalFields, label: strings.searchDoctors.allSubMedicalFields, isSelected: true }]);
      // setSubMedicalFields(subFieldsObjects && subFieldsObjects.length > 0 ? [{ value: strings.searchDoctors.allSubMedicalFields, label: strings.searchDoctors.allSubMedicalFields, isSelected: true }, ...subFieldsObjects] : []);     
      setSubMedicalFields(subFieldsObjects && subFieldsObjects.length > 0 ? subFieldsObjects : []);
    }
    else {
      setIsMedicalFieldWithSubField(false);
    }
  }

  return (
    <div
      className={getAllClassNames([
        "ais-InstantSearch",
        isDev() && styles.devContainer,
      ])}
    >
      <InstantSearch
        indexName={DOCTORS}
        searchClient={searchClient}
      >
        <div className={styles.container}>
          <div
            className={getAllClassNames([
              styles.searchDiv,
              expanded && styles.noBorderBottom,
            ])}
          // style={{ justifyContent: objectType !== 1 ? 'flex-start' : 'center', paddingInlineStart: objectType !== 1 ? '70px' : '' }}
          >
            {objectType === 1 && <div className={styles.divFlex}>
              <CustomLocalSearchInput
                forceReset
                isPopup
                popupProps={{
                  title: strings.searchDoctors.chooseMedicalField,
                  subTitle: strings.searchDoctors.canChooseMedicalField,
                  placeholder: strings.searchDoctors.searchMedicalField,
                  keyToNormalize: 'medicalFieldName',
                  labelToNormalize: 'medicalFieldName',
                  //filterBy: 'medicalFieldName',
                  onSubmit: () => { },
                }}
                enableFreeText
                selectedSubBubbles={subBubbles}
                queryParams={[{ key: 'objectType', value: objectType }]}
                setSelectedSubBubbles={handleSetSelectedCheckboxes}
                attribute={localAttributes.localMedicalApiKey}
                title={strings.searchDoctors.medicalField}
                onContinue={(value: string, hasSubField: boolean) => { handleSelectedMedicalField(value, hasSubField) }}
                onChange={(value: string, hasSubField: boolean) => { handleSelectedMedicalField(value, hasSubField) }}
                onReset={handleResetField}
              />
              {isMedicalFieldWithSubField ? (
                <CustomDropdownCheckboxes
                  ref={dropdownRef}
                  onSelected={updateSubBubbles}
                  selectedCheckBoxes={selectedSubBubbles}
                  selectOptions={subMedicalFields}
                  title={strings.searchDoctors.subField}
                  setQueryParams={(items: string[]) => setSubField(items)}
                />
              ) : null}
            </div>
            }
            <CustomLocalSearchInput
              forceReset
              popupProps={{
                title: '',
                subTitle: '',
                placeholder: '',
                keyToNormalize: 'name',
                labelToNormalize: 'fullName',
                //filterBy: 'medicalFieldName',
                onSubmit: () => { },
              }}

              enableFreeText
              attribute={localAttributes.localDoctorNamesApiKey}
              title={strings.searchDoctors.name}
              queryParams={[{ key: 'objectType', value: objectType }]}
              onChange={(value: string) => setName(value)}
              onReset={() => setName('')}
            />
            <CustomLocalSearchInput
              forceReset
              multiSelect
              isPopup
              popupProps={{
                title: strings.globalStrings.chooseCity,
                subTitle: strings.globalStrings.canChooseCity,
                placeholder: strings.globalStrings.searchCity,
                keyToNormalize: 'cityCode',
                labelToNormalize: 'city',
                //filterBy: 'city',
                onSubmit: () => { },
              }}
              placeholder={strings.globalStrings.cityPlaceholder}

              enableFreeText
              attribute={localAttributes.localCitiesApiKey}
              title={strings.globalStrings.city}
              queryParams={[{ key: 'objectType', value: objectType }]}
              onChange={(value: string) => { setCity(value) }}
            //onReset={() => setCity('')}
            />
          </div>
          {expanded && (
            <div className={styles.divExpand} ref={divExpandRef}>
              <CustomCheckboxesLocal
                onSetSelected={(selectedData: string[]) => { setGender(selectedData) }}
                title={strings.searchDoctors.doctorGender}
                options={doctorGenderOptions}
                selectedCheckboxes={gender}
              />
              <CustomCheckboxesLocal
                isFlex
                onSetSelected={(selectedData: string[]) => setDaysOfWeek(selectedData)}
                title={strings.globalStrings.visitDays}
                options={visitDaysOptions}
                selectedCheckboxes={daysOfWeek}
                isSpecialAriaLabel={true}
              />
              <CustomCheckboxesLocal
                onSetSelected={(selectedData: string[]) => setWorkHours(selectedData)}
                title={strings.globalStrings.visitHours}
                options={visitHoursOptions}
                selectedCheckboxes={workHours}
              />
              {objectType !== 2 && <CustomCheckboxesLocal
                limitWidth
                onSetSelected={(selectedData: string[]) => setLanguages(selectedData)}
                title={strings.globalStrings.languages}
                options={languagesOptions}
                selectedCheckboxes={languages}
              />
              }
            </div>
          )}
          {settings.showAdvanceSearch ?
            <div className={styles.divBottom}>
              <div>
                <Text
                  onClick={() => setExpanded(!expanded)}
                  className={styles.textAdvance}
                  text={expanded ? strings.globalStrings.closeAdvancedSearch : strings.globalStrings.advanceSearch}
                  ariaLabel={expanded ? strings.globalStrings.closeAdvancedSearch : strings.globalStrings.advanceSearch}
                />
                {expanded ? (
                  // <ArrowUp className={styles.icon} />
                  <SvgGenerator name="ArrowUp" className={styles.icon} objectName="doctorsSearch" />
                ) : (
                  // <ArrowLeft className={styles.icon} />
                  <SvgGenerator name="ArrowLeft" className={styles.icon} objectName="doctorsSearch" />
                )}
              </div>

              <Button
                onClick={onSubmit}
                text={strings.globalStrings.search}
                replaceClassName={styles.button}
              />
            </div> :
            <div className={styles.divBottomNoAavanced}>
              <Button
                onClick={onSubmit}
                text={strings.globalStrings.search}
                replaceClassName={styles.button}
              />
            </div>
          }
        </div>
        {
          <Popup
            ref={popupRef}
            onClose={() => handleToggleVisibility()}
            height={284}
            width={550}
            style={{ paddingBottom: '0px' }}
          >
            <AlertPopup
              title={strings.errorMessages.notice}
              subTitle={strings.errorMessages.requiredProperties}
              showButton
              buttonText={strings.globalStrings.close}
              onClose={() => handleToggleVisibility()}
            ></AlertPopup>
          </Popup>
        }
      </InstantSearch>
    </div>
  );
}
